import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProtection = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 48,
			rx: 6,
			fill: "#DEDBFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M32 17.1169V22.7267C32 27.7811 28.7796 32.2698 24 33.8929C19.2204 32.2698 16 27.7811 16 22.7267V17.1169C18.5793 16.981 21.0864 16.1898 23.2816 14.8121L24 14.3612L24.7184 14.8121C26.9136 16.1898 29.4207 16.981 32 17.1169ZM23.7641 14.2131C23.7643 14.2133 23.7646 14.2135 23.7648 14.2136L23.7641 14.2131ZM34 22.7267V16.3381C34 15.6753 33.4626 15.1379 32.7998 15.1379C30.317 15.1379 27.8845 14.4378 25.7816 13.1181L24.8272 12.5191C24.3214 12.2017 23.6786 12.2017 23.1728 12.5191L22.2184 13.1181C20.1155 14.4378 17.683 15.1379 15.2002 15.1379C14.5374 15.1379 14 15.6753 14 16.3381V22.7267C14 28.674 17.8122 33.9516 23.4582 35.8206C23.81 35.9371 24.19 35.9371 24.5418 35.8206C30.1878 33.9516 34 28.674 34 22.7267Z",
			fill: "#534ABA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.9419 24.439L23.9736 25.1499C23.9736 25.6323 23.8488 26.0111 23.5991 26.2861H27.4585V28H20.6729V26.2861H21.3267C21.5679 26.2227 21.6948 26.0047 21.7075 25.6323L21.7139 25.2959L21.6821 24.439H20.6538V22.7822H21.6313L21.5933 21.4048C21.5933 20.5373 21.8514 19.8602 22.3677 19.3735C22.8882 18.8826 23.5907 18.6372 24.4751 18.6372C25.423 18.6372 26.1615 18.8805 26.6904 19.3672C27.2236 19.8538 27.4902 20.514 27.4902 21.3477H25.3955C25.3955 20.6833 25.1077 20.3511 24.5322 20.3511C24.3164 20.3511 24.1429 20.4378 24.0117 20.6113C23.8805 20.7806 23.8149 21.0451 23.8149 21.4048L23.8721 22.7822H25.8208V24.439H23.9419Z",
			fill: "#534ABA"
		})
	]
});
export default SvgProtection;
